import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  spokenTerms?: string[];
};

export function CallSummarySpokenTerms(props: Props): JSX.Element {
  const { spokenTerms } = props;
  const hasSpokenTerms = Boolean(spokenTerms?.length);

  return (
    <div className="card">
      <div className="card-header px-0 py-1" id="headingSpokenTerms">
        <button
          className="btn btn-link btn-block text-left text-decoration-none text-site siteAccordion collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#call-spoken-terms"
          aria-expanded="true"
          aria-controls="call-spoken-terms"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>Spoken Terms</div>
            <div>
              <FontAwesomeIcon
                icon={faChevronDown}
                className="closed-panel-icon"
              />
              <FontAwesomeIcon
                icon={faChevronUp}
                className="open-panel-icon"
              />
            </div>
          </div>
        </button>
      </div>
      <div
        className="collapse"
        id="call-spoken-terms"
        aria-labelledby="headingSpokenTerms"
        data-parent="#call-summary-panels"
      >
        <div className="card-body px-3 py-2">
          {!hasSpokenTerms ? (
            <div className="text-muted">There are no spoken terms</div>
          ) : (
            <div className="d-flex flex-wrap">
              {spokenTerms?.map((term, index) => (
                <span
                  key={`${term}-${index}`}
                  className="badge font-weight-normal mr-2 mb-2 px-2 py-1"
                  style={{
                    borderRadius: "999px",
                    backgroundColor:
                      "var(--spoken-terms-pill-bg, rgba(108, 117, 125, 0.14))",
                    color: "var(--text)",
                    fontSize: "0.75rem",
                    lineHeight: 1.2,
                  }}
                >
                  {term}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
